import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const restoreSurveyAction = createAsyncThunk(
    'restore-survey',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/restore-survey/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const restoreSurveySlice = createSlice({
    name: 'restore-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(restoreSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(restoreSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(restoreSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const restoreSurveyReducer = restoreSurveySlice.reducer    